// chat_menu, from the Henry AI Advisor Energy Tracking plan: the member opened the
// AI Adviser from this app's nav. It fires before OttoChat mounts, so it is the one
// plan event this app sends itself; every other chat_* event comes from otto-ui
// through the OttoHost `track` capability (nuxtHost.ts).
//
// vertical and agent come from otto-ui's OTTO_ANALYTICS_CONTEXT so they always
// match its own events. Imported lazily: a static import would pull the chat bundle
// into the nav, and the page this click opens loads it anyway.

export type ChatMenuLocation = 'sidebar' | 'bottom_nav'

interface ChatTracking {
  chat (event: string, params: Record<string, unknown>): void
}

// Pass `$tracking` from the caller's setup: by the time the import resolves there
// is no Nuxt context to read it from. Never throws - analytics must not break
// navigation.
export async function trackChatMenu (tracking: ChatTracking | undefined, menuLocation: ChatMenuLocation): Promise<void> {
  try {
    const { OTTO_ANALYTICS_CONTEXT } = await import('@compareclub/otto-ui')
    tracking?.chat('chat_menu', { ...OTTO_ANALYTICS_CONTEXT, menu_location: menuLocation })
  } catch {
    // Analytics never blocks the nav.
  }
}
